module.exports = __webpack_public_path__ + "img/mb.f1532392.svg";